import React from "react";
import styles from "./DynamicSquaredFilterBar.module.scss";
import { Col, Row } from "reactstrap";

const DynamicSquaredFilterBar = ({
    tabs,
    activeTab,
    setActiveTab,
    barType = "default",
}) => {
    const formattedBarType = barType.toLowerCase();

    return (
        <div className={`${styles.filterBarContainer}`}>
            <Row className={`${styles.tabRow} ${styles[`tabRow-${formattedBarType}`]}`}>
                {tabs.map((tab) => (
                    <Col
                        key={tab.key}
                        className={`${styles.tab} ${styles[`tab-${formattedBarType}`]} ${activeTab === tab.key ? styles.activeTab : ""}`}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default DynamicSquaredFilterBar;